import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { PersonApplication } from 'src/app/shared/models/application/personApplication';
import { PortalFormDetailsComponent } from 'src/portal/components/portal-form-details/portal-form-details.component';
import { PortalFormService } from './portal-form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-portal-form',
  templateUrl: './portal-form.component.html',
  styleUrls: ['./portal-form.component.scss'],
  standalone: false
})
export class PortalFormComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private triggerElement: HTMLElement | null = null;
  public personId: string;
  public completedApplications: PersonApplication[] = [];
  public isFormLoading: boolean = true;
  public isSideBarOpen: boolean = false;
  @ViewChild(PortalFormDetailsComponent) details: PortalFormDetailsComponent;
  constructor(
    private portalFormService: PortalFormService,
    private route: ActivatedRoute,
    private router: Router,
    private oidcSecurityService: OidcSecurityService
  ) {}

  ngOnInit(): void {
    // Subscribe to parent route params to get personId (since we're a child route)
    this.subscriptions.push(
      this.oidcSecurityService.getUserData().subscribe((userData) => {
        if (userData && userData.sub) {
          // The 'sub' claim typically contains the user ID
          this.personId = userData.sub;
          this.portalFormService.getForms(this.personId).then((forms) => {
            this.completedApplications = forms.filter((x) => x.isCompleted);
            this.isFormLoading = false;
          });
        } else {
          // If we can't determine the personId, redirect to home or show error
          this.isFormLoading = false;
          this.router.navigate(['/portal']);
        }
      })
    );
  }

  openDetails(application: PersonApplication, event: Event) {
    this.triggerElement = event.currentTarget as HTMLElement;
    this.details.open(application);
    this.isSideBarOpen = true;
    event.preventDefault();
  }

  onPanelClosed(): void {
    this.isSideBarOpen = false;
    setTimeout(() => {
      this.triggerElement?.focus();
      this.triggerElement = null;
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  display(application: PersonApplication): void {
    // Navigate using the new routing structure
    this.router.navigate(
      [
        {
          outlets: {
            primary: 'list',
            details: `form/${application.applicationId}`
          }
        }
      ],
      { relativeTo: this.route.parent }
    );
  }
}
